module.exports = __webpack_public_path__ + "img/clock-icon.a458f52e.svg";